const DEFAULT_COS_BASE = 'https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/';
export const FILETYPE_ICON_BASE = `${DEFAULT_COS_BASE}assets/filetype/`;

export function getCosBase(vm) {
  const cosBase = vm && vm.$cos && vm.$cos.defaults && vm.$cos.defaults.baseURL;
  return String(cosBase || DEFAULT_COS_BASE).replace(/\/$/, '');
}

export function toFullFileUrl(url, cosBase) {
  if (!url) {
    return '';
  }
  const text = String(url).trim();
  if (/^https?:\/\//i.test(text)) {
    return text;
  }
  const base = String(cosBase || DEFAULT_COS_BASE).replace(/\/$/, '');
  const path = text.startsWith('/') ? text.slice(1) : text;
  if (path.startsWith('files/')) {
    return `${base}/${path}`;
  }
  return `${base}/files/${path}`;
}

export function getFileExt(nameOrUrl) {
  if (!nameOrUrl) {
    return '';
  }
  const text = String(nameOrUrl);
  const dot = text.lastIndexOf('.');
  if (dot === -1) {
    return '';
  }
  return text.substring(dot + 1).toLowerCase().split('?')[0].split('#')[0];
}

export function isImageExt(ext) {
  return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'ico'].includes(String(ext || '').toLowerCase());
}

export function getFileTypeIconUrl(ext) {
  const safeExt = getFileExt(ext) || String(ext || '').toLowerCase() || 'file';
  return `${FILETYPE_ICON_BASE}${safeExt}.png`;
}

function fallbackDownload(url, filename) {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  if (filename) {
    link.download = filename;
  }
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function downloadFormViewFile(vm, url, name) {
  const fullUrl = toFullFileUrl(url, getCosBase(vm));
  if (!fullUrl) {
    return;
  }
  const filename = name || fileNameFromUrl(fullUrl);
  const xhr = new XMLHttpRequest();
  xhr.open('GET', fullUrl, true);
  xhr.responseType = 'blob';
  xhr.onload = () => {
    if (xhr.status === 200 && xhr.response) {
      if (vm && typeof vm.SaveAs === 'function') {
        vm.SaveAs(xhr.response, filename);
        return;
      }
      if (vm && typeof vm.DownloadWithName === 'function') {
        vm.DownloadWithName(fullUrl, filename);
        return;
      }
    }
    fallbackDownload(fullUrl, filename);
  };
  xhr.onerror = () => fallbackDownload(fullUrl, filename);
  xhr.send();
}

function fileNameFromUrl(url) {
  if (!url) {
    return '文件';
  }
  const matched = String(url).replace(/(.*\/)*([^.?#]+)/i, '$2');
  if (matched && matched !== url) {
    try {
      return decodeURIComponent(matched);
    } catch (e) {
      return matched;
    }
  }
  const part = String(url).split('/').pop();
  return part ? part.split('?')[0] : '文件';
}

function mapResolvedFile(file, ref, cosBase) {
  const url = toFullFileUrl(file.url || file.path || '', cosBase);
  const name = (ref && ref.name) || file.name || fileNameFromUrl(url);
  const ext = String(file.ext || getFileExt(name) || getFileExt(url) || 'file').toLowerCase();
  return {
    url,
    name,
    ext,
  };
}

/**
 * 将 UgoFile 控件 value 解析为 {url,name}[]（支持 file_id 引用与直链）
 */
export function resolveFormViewFiles(vm, value) {
  const cosBase = getCosBase(vm);
  if (!Array.isArray(value) || value.length === 0) {
    return Promise.resolve([]);
  }

  const withUrl = value.filter((f) => f && typeof f === 'object' && (f.url || f.path));
  if (withUrl.length === value.length) {
    return Promise.resolve(withUrl.map((f) => mapResolvedFile(f, f, cosBase)));
  }

  let refs = [];
  if (value.every((item) => typeof item === 'string' || typeof item === 'number')) {
    refs = value.map((id) => ({file_id: id}));
  } else {
    refs = value.filter((f) => f && (f.file_id || f.id));
  }

  if (!refs.length) {
    return Promise.resolve([]);
  }

  const ids = refs.map((f) => f.file_id || f.id).filter(Boolean);
  if (!ids.length || !vm || !vm.$api) {
    return Promise.resolve(refs.map((f) => ({
      url: '',
      name: f.name || '文件',
    })));
  }

  return new Promise((resolve) => {
    const request = () => {
      vm.$api.post('files/get', ids).then((res) => {
        const list = res.data.data || [];
        resolve(list.map((file) => {
          const ref = refs.find((t) => (t.file_id || t.id) == file.id);
          return mapResolvedFile(file, ref, cosBase);
        }));
      }).catch(() => {
        resolve(refs.map((f) => ({
          url: '',
          name: f.name || '文件',
        })));
      });
    };

    if (typeof vm.$api.afterLogin === 'function') {
      vm.$api.afterLogin(request);
    } else {
      request();
    }
  });
}
